module.exports = __webpack_public_path__ + "img/service_curr03.d6d7677e.png";